import React, {useState} from "react";
import auth from "../../../utils/authentication";
import {Link, useNavigate} from "react-router-dom";
import {FormattedMessage, useIntl} from "react-intl";
import GoogleLogin from "../googleLogin/googleLogin";
import {goHomeAfterLogin, isMobileDevice, validateEmail} from "../../../utils/utils";
import {fetchSignInMethodsForEmail, updateProfile} from 'firebase/auth';
import functions from "../../../utils/functionsFirebase";
import app from '../../app';
import {useDispatch} from "react-redux";
import avatarDefault from "../../../images/avatardefault.png"

function SignIn({setCurrentPage, onFinishLogin}) {

    const intl = useIntl();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [userName, setUserName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [passConfError, setPassConfError] = useState(false);
    const [validForm, setValidForm] = useState(false);

    const signInUser = (e) => {
        e.preventDefault();
        dismissError();

        auth.createUserWithEmailAndPassword(email, password)
            .then((userCredential) => {
                // User successfully signed in
                const user = userCredential.user;
                dispatch(app.actions.loading());
                onFinishLogin();
                if(goHomeAfterLogin()){
                    navigate('/home');
                }

                updateProfile(user, {
                    displayName: userName,
                    photoURL: avatarDefault
                }).then(() => {
                    const updateUserCode = functions.httpsCallable('updateUserCode');
                    updateUserCode({userName, userId: user.uid}).then(
                        () => {
                            auth.signInWithEmailAndPassword(email, password).then(r => {
                                dispatch(app.actions.loaded());
                            }).catch((error) => {
                                console.log(error);
                            });
                        });
                });
            })
            .catch((error) => {
                // Handle any errors that occur during sign in
                document.querySelectorAll('input').forEach(x => x.classList.add('is-invalid'))
                setError('error creando la cuenta');
                console.log(error.toString())
                // Handle the error accordingly
            });
    }

    // Función para verificar la existencia del correo electrónico
    const checkEmailExistence = async (email) => {
        try {
            const methods = await fetchSignInMethodsForEmail(auth, email);
            return methods.length > 0; // Si la longitud de los métodos es mayor a 0, el correo electrónico existe
        } catch (error) {
            console.error('Error checking email existence:', error);
            // Manejar el error según sea necesario
        }
    };

    async function getEmailError(input) {
        if (!input.value) {
            setEmailError('');
            return;
        }
        if (!validateEmail(input.value)) {
            setEmailError(intl.formatMessage({id: `users.signup.invalid-email`}));
        } else {
            checkEmailExistence(input.value).then(res => {
                if (res) {
                    setEmailError(intl.formatMessage({id: `users.signup.email-used`}));
                } else {
                    setEmailError('success');
                }
            });
        }
    }

    async function getPasswordError(value) {
        if (!value) {
            setPasswordError(false);
            return;
        }
        if (value.length < 6) {
            setPasswordError(true);
        } else {
            setPasswordError(false);
        }
    }


    async function getPassConfError(value) {
        if (!value) {
            setPassConfError(false);
            return;
        }
        if (value !== password) {
            setPassConfError(true);
        } else {
            setPassConfError(false);
        }
    }

    function validate() {
        //email
        let success = true;
        //password

        const passwordInput = document.getElementById('passwordInput');
        if (passwordInput.value.length < 6) {
            document.getElementById('passwordInput')?.classList.add('is-invalid');
            document.getElementById('confPasswordInput')?.classList.remove('is-invalid');
            success = false;
            setValidForm(success);
            return success;
        } else {
            document.getElementById('passwordInput')?.classList.remove('is-invalid');
        }

        const confPasswordInput = document.getElementById('confPasswordInput');
        if (passwordInput.value !== confPasswordInput.value) {
            document.getElementById('confPasswordInput')?.classList.add('is-invalid');
            success = false;
        } else {
            document.getElementById('confPasswordInput')?.classList.remove('is-invalid');
        }

        setValidForm(success);
        return success;
    }

    function dismissError() {
        setError("");
        document.querySelectorAll('input').forEach(x => x.classList.remove('is-invalid'))
    }

    const colSize = isMobileDevice() ? "col-10" : "col-7";

    return (
        <div>
            <div className="col-12 text-center">
                <GoogleLogin onFinishLogin={onFinishLogin}/>
            </div>
            <div className="d-flex flex-row align-items-center col-12 justify-content-center">
                <hr className="col-4 me-3"/>
                <span className="text-center"><FormattedMessage id="users.login.or"/></span>
                <hr className="col-4 ms-3"/>
            </div>
            <form className="d-flex flex-row flex-wrap col-12 justify-content-center" autoComplete="false">
                {error && <div className="alert alert-danger alert-dismissible fade show col-7" role="alert">
                    {error}
                    <button type="button" className="btn-close" onClick={() => dismissError()}/>
                </div>}
                <input autoComplete="false" name="hidden" type="text" style={{display: "none"}}/>

                <div className={"form-floating mb-3 " + colSize}>
                    <input id="userInput" onBlur={e => {
                        setUserName(e.target.value);
                    }} autoComplete="false" maxLength="20" placeholder="Nombre de usuario"
                           type="text"
                           className={"form-control " + (userName && " is-valid ")} />
                    <label htmlFor="userInput"><FormattedMessage id="users.input.user"/> *</label>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="emailInput" onBlur={e => {
                        setEmail(e.target.value);
                        getEmailError(e.target);
                    }} autoComplete="false"
                           type="email"
                           className={"form-control "
                               + ((email && emailError && emailError !== 'success') && " is-invalid ")
                               + ((email && emailError === 'success') && " is-valid ")}
                           placeholder="Correo electrónico"/>
                    <label htmlFor="emailInput"><FormattedMessage id="users.input.email"/> *</label>
                    {(emailError && emailError !== 'success') &&
                        <div className="invalid-feedback">
                            {emailError}
                        </div>}
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="passwordInput" onBlur={e => {
                        setPassword(e.target.value);
                        getPasswordError(e.target.value);
                        getPassConfError(confirmPassword);
                    }} autoComplete="new-password" type="password" placeholder="Contraseña"
                           className={"form-control " + (password && ((passwordError) ? "is-invalid" : "is-valid"))}/>
                    <label htmlFor="passwordInput"><FormattedMessage id="users.input.password"/> *</label>
                    <small>
                        <FormattedMessage id="users.password-format"/>
                    </small> <br/>
                </div>
                <div className={"form-floating mb-3 " + colSize}>
                    <input id="confPasswordInput" onChange={e => {
                        setConfirmPassword(e.target.value);
                        getPasswordError(password);
                        getPassConfError(e.target.value);
                    }} autoComplete="new-password" placeholder="Confirmar contraseña" type="password"
                           className={"form-control " + (confirmPassword && (passConfError ? "is-invalid" : "is-valid"))}/>
                    <label htmlFor="confPasswordInput"><FormattedMessage id="users.input.confirm-password"/> *</label>
                    {passConfError && <div className="invalid-feedback">
                        <FormattedMessage id="users.signup.password-unmatched"/>
                    </div>}
                </div>
                <div className={"mb-3 " + colSize + " d-flex flex-row align-items-center justify-content-between"}>
                    <button className="btn btn-primary" type="submit" disabled={passConfError || passwordError || !userName || emailError.length > 7} onClick={e => {
                        signInUser(e);
                    }}><FormattedMessage id="users.login.sign-up"/></button>
                    <small><FormattedMessage id="app.required-fields"/></small>
                </div>
                <div className={"mb-3 " + colSize}>
                    <b><FormattedMessage id="users.login.already-have-account"/></b> &nbsp;
                    <a className="link-body-emphasis" style={{cursor: "pointer"}} onClick={() => setCurrentPage("login")}><FormattedMessage id="users.login.log-in"/></a>
                </div>
            </form>
        </div>
    )
}

export default SignIn;
